export const DeliveryPointsScopes = {
  ALL: 'ALL',
  SELECTION: 'SELECTION',
} as const;

export type DeliveryPointsScope = typeof DeliveryPointsScopes[keyof typeof DeliveryPointsScopes];
